import React from "react";
import {
  RiInstagramLine,
  RiTwitterLine,
  RiLinkedinLine,
  RiGithubLine,
} from "react-icons/ri";
import "./footer.css";
function Footer() {
  return (
    <footer className="hero">
      <div className="container flex">
        <div className="container__about">
          <h3 style={{ color: "white" }}>About</h3>
          <p>
            A young software developer, starting his professional life, learning
            the most used languages in this industry, PYTHON, C++, HTML, CSS and
            JAVASCRIPT.
          </p>
        </div>
        <div className="container-pages flex">
          <div className="container__recentpages">
            <h3 style={{ color: "white" }}>Recent Pages</h3>
            <ul>
              <li>
                <a href="">Countries</a>
              </li>
              <li>
                <a href="">Portfolio</a>
              </li>
              <li>
                <a href="">Cartagena-cooks</a>
              </li>
              <li>
                <a href="">Work-company</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="line__separete"></div>
      <div className="by flex">
        <p>
          Copyright ©️ 2023 All Rights Reserved by Ralph Antoun & Ahmad Shakik.
        </p>
        <div className="icons">
          <a href="" className="icon1 icon--instagram">
            <RiInstagramLine />
          </a>
          <a href="#" className="icon1 icon--twitter">
            <RiTwitterLine />
          </a>
          <a href="" className="icon1 icon--linkedin">
            <RiLinkedinLine />
          </a>
          <a href="" className="icon1 icon--github">
            <RiGithubLine />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
